import { render, staticRenderFns } from "./HomeMainTitle.vue?vue&type=template&id=6bc6552a&scoped=true&lang=pug&"
import script from "./HomeMainTitle.vue?vue&type=script&lang=js&"
export * from "./HomeMainTitle.vue?vue&type=script&lang=js&"
import style0 from "./HomeMainTitle.vue?vue&type=style&index=0&id=6bc6552a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6552a",
  null
  
)

export default component.exports